import { Helmet } from "react-helmet";

/**
 * Renders a self-referencing canonical <link> that always points to the
 * current page's clean URL (origin + pathname only, all query params stripped).
 *
 * This tells Google which URL is the "master copy" of the page, preventing
 * UTM / tracking parameters (?utm_source=, ?cid=, ?tid=, etc.) from being
 * treated as separate pages and diluting ranking signals.
 *
 * Usage: drop <CanonicalTag /> anywhere inside a route component's JSX,
 * alongside or inside an existing <Helmet> block.
 */
export function CanonicalTag() {
  const canonicalUrl = `${window.location.origin}${window.location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
